export {
    Link,
    ConditionalWrapper,
    type LinkType,
    type LinkProps,
    type BgColors
} from "./link";
export { Link as default } from "./link";
